import { useQuery } from '@tanstack/react-query';
import request from '#api/axios';
import { Gym } from '#types/gyms';
import { debounce } from 'lodash';

const fetchGym = debounce(async (name: string) => {
  if (!name) return [];

  const { data: gyms } = await request<Gym[]>({
    url: '/gyms/dup-check',
    method: 'POST',
    data: { name }
  });
  return gyms;
}, 300);

export default function useSearchGymsQuery(name: string) {
  return useQuery(['gyms', 'search', name], fetchGym.bind(null, name), {
    enabled: !!name
  });
}
